"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _react = require("react");
var _cnbuilder = require("cnbuilder");
var _reactI18next = require("react-i18next");
var _reactPhoneNumberInput = _interopRequireWildcard(require("react-phone-number-input"));
var _arrowDownDefault = _interopRequireDefault(require("@teladoc/pulse/icons/arrow-down-default.svg"));
var _lockDefault = _interopRequireDefault(require("@teladoc/pulse/icons/lock-default.svg"));
var _environment = _interopRequireDefault(require("@livongo/utilities/system/environment"));
var _useValidation = _interopRequireDefault(require("../Form/use-validation"));
var _useLabelValidation = _interopRequireDefault(require("../Form/use-label-validation"));
var _TextInputModule = _interopRequireDefault(require("../TextInput/TextInput.module.scss"));
var _PhoneInputModule = _interopRequireDefault(require("./PhoneInput.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["classNameRoot", "classNameControl", "classNameCountry", "classNameItem", "testAttrRoot", "testAttrControl", "testAttrCountry", "testAttrItem", "testAttrError", "i18nItemLabel", "i18nCountryLabel", "name", "id", "label", "placeholder", "required", "disabled", "error", "customValidationError", "defaultValue", "helpNode", "readOnly", "countryOptionsOrder", "defaultCountry", "showCountrySelect", "countrySelectName", "disableCountrySelect", "showCallingCode", "flagUrl", "onChange", "onCountryChange", "onFocus", "onBlur", "onInvalid"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const PhoneInput = _ref => {
  let {
      classNameRoot,
      classNameControl,
      classNameCountry,
      classNameItem,
      testAttrRoot,
      testAttrControl,
      testAttrCountry,
      testAttrItem,
      testAttrError,
      i18nItemLabel,
      i18nCountryLabel,
      name,
      id,
      label,
      placeholder,
      required,
      disabled,
      error,
      customValidationError,
      defaultValue,
      helpNode,
      readOnly,
      countryOptionsOrder,
      defaultCountry,
      showCountrySelect,
      countrySelectName,
      disableCountrySelect,
      showCallingCode,
      flagUrl,
      onChange,
      onCountryChange,
      onFocus,
      onBlur,
      onInvalid
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const [callingCode, setCallingCode] = (0, _react.useState)((0, _reactPhoneNumberInput.getCountryCallingCode)(defaultCountry));
  const [value, setValue] = (0, _react.useState)(defaultValue);
  const [countryOrder, setCountryOrder] = (0, _react.useState)(countryOptionsOrder);
  const {
    ref,
    errorId,
    isValid,
    errorElement,
    showInvalid,
    setValidationState
  } = (0, _useValidation.default)({
    id,
    disabled,
    error,
    customValidationError,
    onInvalid
  });
  const isWindows = _environment.default.isWindows();
  const onChangeCallback = val => {
    setValidationState(null);
    setValue(val);
    ref.current.setCustomValidity((0, _reactPhoneNumberInput.isValidPhoneNumber)(val || '') && (0, _reactPhoneNumberInput.isPossiblePhoneNumber)(val) ? '' : ref.current.value.length < 1 ? '' : 'Invalid');
    if (onChange) {
      onChange(val);
    }
  };
  const onCountryChangeCallback = countryCode => {
    if (countryCode) {
      setCallingCode((0, _reactPhoneNumberInput.getCountryCallingCode)(countryCode));
    }
    if (onCountryChange) {
      onCountryChange(countryCode);
    }
  };
  const describedBy = [];
  if (helpNode) {
    describedBy.push("".concat(id, "-help"));
  }
  if (showInvalid) {
    describedBy.push(errorId);
  }
  if (defaultCountry && !countryOrder) {
    setCountryOrder([defaultCountry, '...']);
  }
  (0, _useLabelValidation.default)(label, i18nItemLabel, rest);
  (0, _react.useEffect)(() => {
    setValidationState(null);
  }, [disabled, setValidationState]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({
    className: (0, _cnbuilder.cnb)(_TextInputModule.default.root, _PhoneInputModule.default.root, {
      [_TextInputModule.default.withHelpNode]: Boolean(helpNode)
    }, {
      [_TextInputModule.default.readOnly]: readOnly
    }, {
      [_TextInputModule.default.rightIcon]: readOnly
    }, {
      [_PhoneInputModule.default.readOnly]: readOnly
    }, {
      [_PhoneInputModule.default.disabled]: disabled
    }, {
      [_PhoneInputModule.default.noCountrySelect]: !showCountrySelect
    }, {
      [_TextInputModule.default.containsError]: !isValid
    }, {
      [_PhoneInputModule.default.containsError]: !isValid
    }, classNameRoot)
  }, !isValid && {
    'data-invalid-field': true
  }), {}, {
    "data-test": testAttrRoot,
    children: [label && /*#__PURE__*/(0, _react.cloneElement)(label, {
      className: _TextInputModule.default.label,
      htmlFor: id,
      required
    }), helpNode && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _PhoneInputModule.default.helpNode,
      id: "".concat(id, "-help"),
      children: helpNode
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _cnbuilder.cnb)(_TextInputModule.default.control, classNameControl),
      "data-test": testAttrControl,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactPhoneNumberInput.default, _objectSpread(_objectSpread(_objectSpread({
        ref: ref,
        id: id,
        numberInputProps: _objectSpread({
          className: (0, _cnbuilder.cnb)(_TextInputModule.default.item, _TextInputModule.default['phone-input'], {
            [_PhoneInputModule.default["callingCode".concat(callingCode.length)]]: showCallingCode
          }, classNameItem),
          'data-test': testAttrItem,
          'aria-label': i18nItemLabel
        }, describedBy.length && {
          'aria-describedby': describedBy.join(' ')
        }),
        name: name,
        placeholder: placeholder,
        countryOptionsOrder: countryOrder,
        defaultCountry: defaultCountry,
        addInternationalOption: false,
        countrySelectProps: {
          className: (0, _cnbuilder.cnb)({
            [_PhoneInputModule.default.readOnlySelect]: readOnly
          }, classNameCountry),
          name: countrySelectName,
          'data-test': testAttrCountry,
          'aria-label': i18nCountryLabel || t('ui:phoneInput.country'),
          disabled: disableCountrySelect,
          arrowComponent: _arrowDownDefault.default,
          readOnly
        }
      }, disableCountrySelect && {
        international: false
      }), {}, {
        value: value,
        required: required,
        disabled: disabled,
        readOnly: readOnly,
        focusInputOnCountrySelection: false,
        flagUrl: flagUrl,
        onChange: onChangeCallback,
        onCountryChange: onCountryChangeCallback,
        onFocus: onFocus,
        onBlur: onBlur
      }, !isWindows && showInvalid && {
        'aria-errormessage': "".concat(errorId)
      }), {}, {
        "aria-invalid": !isValid
      }, rest)), showCallingCode && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: _PhoneInputModule.default.callingCode,
        children: ["+", callingCode]
      }), readOnly && !disabled && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _TextInputModule.default.icon,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_lockDefault.default, {})
      })]
    }), showInvalid && /*#__PURE__*/(0, _react.cloneElement)(errorElement, {
      id: errorId,
      testAttr: testAttrError
    })]
  }));
};
PhoneInput.defaultProps = {
  testAttrRoot: 'phone-input-root',
  testAttrControl: 'phone-input-control',
  testAttrCountry: 'phone-input-country',
  testAttrItem: 'phone-input-item',
  testAttrError: 'phone-input-error',
  defaultCountry: 'US',
  showCountrySelect: true,
  showCallingCode: true,
  countrySelectName: 'countryCode',
  flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg'
};
var _default = exports.default = PhoneInput;